import { useSelector } from "react-redux";
import fileDownload from "js-file-download";

import { api } from "../../../services";
import { DownloadTeamplateStep } from "../../demo/noSolar/steps/DownloadTeamplateStep";

export const DownloadTemplate = ({ ...props }) => {
  const { clusters } = useSelector((state) => state.auth);

  const handleDownload = () => {
    api
      .get("/onboarding/base/portfolio-registration/download-xlsx/", {
        responseType: "blob",
        params: { clusters: clusters?.[0]?.id },
      })
      .then((res) => {
        fileDownload(res.data, "portfolio_registration_template.xlsx");
      });
  };

  return (
    <DownloadTeamplateStep
      downloadText="download the empty table"
      {...props}
      onClick={handleDownload}
    />
  );
};
